import { Plus } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { SaleNote } from "@/components/SaleNote";
import { ValueContrast } from "@/components/ValueContrast";
import { BuyButton } from "@/components/Buttons";
import { ALL_PLAN, TEACHER_LIBRARY, OWNER_LIBRARY, countItems } from "@/data/offer";

const Stack = ({ title, lib, imgs, testId }) => (
  <div data-testid={testId} className="flex-1 border border-ink/15 bg-white p-6 sm:p-8">
    <div className="flex items-baseline justify-between gap-3">
      <h3 className="font-display text-2xl font-medium text-ink">{title}</h3>
      <span className="font-display text-xl text-red">{countItems(lib)}</span>
    </div>
    <div className="mt-6 grid grid-cols-4 gap-2">
      {imgs.map((src, i) => (
        <div key={i} className="aspect-square bg-alabaster">
          <img src={src} alt="" loading="lazy" className="h-full w-full object-contain p-1.5" />
        </div>
      ))}
    </div>
    <ul className="mt-6 space-y-1.5 text-[13px] text-ink/60">
      {lib.map((g) => (
        <li key={g.category} className="flex items-center gap-2">
          <span className="h-1 w-1 bg-red" />
          {g.category}
        </li>
      ))}
    </ul>
  </div>
);

export const AllInOne = () => {
  const tImgs = TEACHER_LIBRARY.flatMap((g) => g.items.map((i) => i.img)).slice(0, 8);
  const oImgs = OWNER_LIBRARY.flatMap((g) => g.items.map((i) => i.img)).slice(0, 4);

  return (
    <section id="mam-wszystko" data-testid="all-in-one-section" className="bg-alabaster py-20 sm:py-28">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
        <Reveal className="max-w-[820px]">
          <Eyebrow>Abonament łączony</Eyebrow>
          <h2 className="font-display mt-5 text-5xl font-medium leading-[0.98] tracking-[-0.02em] text-ink sm:text-6xl lg:text-7xl">
            Abonament: Chcę mieć wszystko
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink/70 sm:text-xl">
            Dla właścicielki, która chce rozwijać nie tylko swoją szkołę, ale także swoje umiejętności nauczycielskie.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <div className="flex flex-col items-stretch gap-3 md:flex-row md:items-stretch">
              <Stack title="Biblioteka nauczycielska" lib={TEACHER_LIBRARY} imgs={tImgs} testId="all-stack-teacher" />
              <div className="flex items-center justify-center md:w-14">
                <span className="flex h-12 w-12 items-center justify-center bg-red text-white">
                  <Plus className="h-6 w-6" strokeWidth={2.5} />
                </span>
              </div>
              <Stack title="Biblioteka właścicielska" lib={OWNER_LIBRARY} imgs={oImgs} testId="all-stack-owner" />
            </div>
            <p className="mt-6 text-[14px] leading-relaxed text-ink/55">
              Obie biblioteki w jednym dostępie: pełna oferta dla nauczycieli i pełna oferta dla właścicielek,
              łącznie z Treningiem Asertywności i Design Thinking, które pojawiają się w obu.
            </p>
          </Reveal>

          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="h-full bg-ink p-7 text-white sm:p-10">
              <div className="flex items-baseline justify-between border-b border-white/20 pb-6">
                <h3 className="font-display text-2xl font-medium text-white sm:text-3xl">{ALL_PLAN.label}</h3>
              </div>
              <div className="pt-8">
                <ValueContrast value={ALL_PLAN.value} price={ALL_PLAN.price} dark testId="all-contrast" />
              </div>
              <BuyButton href={ALL_PLAN.url} testId="all-buy-button" className="mt-10 w-full">
                Wybieram „Chcę mieć wszystko”
              </BuyButton>
              <SaleNote dark />
              <p className="mt-4 text-[12px] leading-relaxed text-white/55">
                Jeden dostęp (1 konto) obejmujący obie biblioteki.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
